import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { H3, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { pushLoginExpressEditUserDetailsClickEventToDataLayer } from "../../../../../../../../data-layer.js";
import { seedFieldState } from "../../../../../../../../StepShipping/mappers/StepShipping/mappers/seed-shipping-form.js";
import { formStatesToValues } from "../../../../../../../utils/LoginExpressCheckout/utils/form-state-to-values.js";
import { isFormDataValid } from "../../../../../../../utils/LoginExpressCheckout/utils/validate-form-data.js";
import { useLoggedInCheckout } from "../../../../../../../context/LoginExpressCheckout/context/context.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
import { useBaseSummarySlot } from "../../../../../../../../slots/summaries/slots/summaries/summary-context.js";
import { useFormSlotWithoutRedux } from "../../../../../../../../slots/forms/slots/forms/form-context.js";
const InvoiceSummary = ({ invoiceDetails, onSubmit, isOrderDetailsValid }) => {
  const { getLabel } = useIntl();
  const { formFieldsMap } = useCheckoutSettings();
  const { isUserLoggedIn } = useLoggedInCheckout();
  const { Slots } = useBaseSummarySlot();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const filledFormData = invoiceDetails && Object.entries(invoiceDetails).reduce(
    (item, [key, value]) => ({ ...item, [key]: seedFieldState(key, value) }),
    {}
  );
  const [invoiceDetailsState, setInvoiceDetailsState] = React.useState();
  const handleSubmit = React.useCallback(
    (invoiceFormState) => {
      const updatedInvoiceDetails = invoiceDetailsState && formStatesToValues(invoiceFormState.formState);
      updatedInvoiceDetails && onSubmit?.({ invoice: updatedInvoiceDetails });
      setIsModalOpen(false);
    },
    [invoiceDetailsState, onSubmit]
  );
  const { invoice: invoiceForm } = useFormSlotWithoutRedux({
    formInitialData: filledFormData ? { invoice: filledFormData } : {},
    onChange: setInvoiceDetailsState,
    onSubmit: handleSubmit,
    onCancel: () => setIsModalOpen(false),
    className: "login-express-checkout__form-modal__form login-express-checkout__form-modal__form--with-custom-height"
  });
  const labels = {
    title: getLabel("checkout.invoice.label"),
    save: getLabel("common.actions.save")
  };
  const isInvoiceDetailsFormComplete = React.useMemo(() => {
    return formFieldsMap?.invoice ? isFormDataValid(formFieldsMap?.invoice, invoiceDetails) ?? false : false;
  }, [invoiceDetails, formFieldsMap?.invoice]);
  const onEditHandler = React.useCallback(() => {
    pushLoginExpressEditUserDetailsClickEventToDataLayer({
      editType: isInvoiceDetailsFormComplete ? "edit_invoice" : "add_invoice_alert",
      isLoggedIn: isUserLoggedIn
    });
    setIsModalOpen(true);
  }, [isInvoiceDetailsFormComplete, isUserLoggedIn]);
  if (!Slots.invoice) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "login-express-checkout__form-modal",
      isOpen: isModalOpen,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true
    },
    /* @__PURE__ */ React.createElement(H3, { variant: "body-head" }, labels.title),
    /* @__PURE__ */ React.createElement(React.Fragment, null, invoiceForm)
  ), /* @__PURE__ */ React.createElement(
    Slots.invoice,
    {
      actions: {
        onEdit: onEditHandler
      },
      values: invoiceDetails,
      errorNotification: !isInvoiceDetailsFormComplete ? /* @__PURE__ */ React.createElement(
        Alert,
        {
          className: "alert-m-default ",
          role: isOrderDetailsValid ? "status" : "alert",
          variant: isOrderDetailsValid ? "info" : "error",
          title: getLabel("checkout.invoice.incomplete.title")
        },
        getLabel("checkout.information.incomplete.message")
      ) : null
    }
  ));
};
export {
  InvoiceSummary
};
//# sourceMappingURL=InvoiceSummary.js.map
